<div class="card">
  <div class="card-header">
    <h3 class="card-title">Completion Report</h3>
  </div>
  <div class="card-body">
    <div class="table-responsive">
      <table
        class="table table-hover table-striped text-nowrap table-vcenter mb-0"
      >
        <thead>
          <tr>
            <th>Project</th>
            <th>Delay</th>
            <th>EOT Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="report.length == 0">
            No data found
          </tr>
          <tr *ngFor="let reportRow of report">
            <td>{{ reportRow.project?.contractTitle }}</td>
            <td>{{ reportRow.delayDays }}</td>
            <td><span class="tag tag-success">Submitted</span></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
